import { getCookie, getTaxiUserInfo } from "@2u-landing-pages/utils/cookieUtils";
import { useEffect } from "react";
import { ensureCalendlyAssets } from "./calendlyAssets";
import { calendlyEventListener } from "./calendlyEvents";

const userInfo = getTaxiUserInfo();
const sessionId = getCookie("tglr_sess_id");

export const hasCalendlyLink = (content: any): boolean => {
  const checkNode = (node: any): boolean => {
    if (!node) return false;

    if (node.nodeType === "hyperlink" && node.data?.uri?.includes("calendly")) {
      return true;
    }

    if (node.content && Array.isArray(node.content)) {
      return node.content.some(checkNode);
    }

    return false;
  };

  return checkNode(content);
};

export const useCalendly = (eventListener?: boolean) => {
  useEffect(() => {
    if (!eventListener) return;

    void ensureCalendlyAssets().catch((error) => {
      console.error("Error loading Calendly assets:", error);
    });

    return calendlyEventListener();
  }, [eventListener]);

  const openCalendlyPopup = async (url: string) => {
    if (typeof window !== "undefined") {
      // Build URL with parameters
      const params = new URLSearchParams();
      params.set("hide_landing_page_details", "1");
      params.set("hide_gdpr_banner", "1");

      const urlWithParams = `${url}?${params.toString()}`;

      try {
        await ensureCalendlyAssets();

        if (!window.Calendly?.initPopupWidget) {
          throw new Error("Calendly widget is unavailable");
        }

        window.Calendly.initPopupWidget({
          url: urlWithParams,
          ...(userInfo && {
            prefill: {
              name: `${userInfo.firstName} ${userInfo.lastName}`,
              email: userInfo.email,
            },
          }),
          utm: {
            utmSource: "rv_thankyoupage",
            utmContent: `session_id_${sessionId}`,
          },
        });
      } catch (error) {
        console.error("Error opening Calendly popup:", error);
      }
    }
  };

  const calendlyClickHandler = (url: string) => {
    return (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      void openCalendlyPopup(url);
      return false;
    };
  };

  return {
    openCalendlyPopup,
    calendlyClickHandler,
    hasCalendlyLink,
  };
};

export default useCalendly;
